<button (click)="open()">{{customerPopupButtonDefinition.label}}</button>
